/*
 * Copyright (c) 2014-2020. webcrab GmbH
 * This file is part of ista VDM.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by <phillip@webcrab.at>
 */

/**
 * Vue filter transform a number to an austrian number with optional rounding
 */
export default (number, round = 4) => {
    const num = Number.parseFloat(number);
    if (Number.isNaN(num)) {
        return null;
    }
    return new Intl.NumberFormat('de-AT', {
        maximumFractionDigits: round,
    }).format(number);
};
